module.exports = "<router-outlet></router-outlet><ng2-toasty></ng2-toasty><confirm></confirm>"


//////////////////
// WEBPACK FOOTER
// ./app/app.component.html
// module id = 1111
// module chunks = 4